
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Menu } from '@/types/menus';

@Component
export default class MenuListTile extends Vue {
  @Prop() menu!: Menu;
}
